import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import UserImport from '@/ui/pages/UserImport/UserImport';

export const Route = createFileRoute('/_dashboard/users/import/$tenantId')({
  beforeLoad: requireRoute('/users/import/$tenantId'),
  component: UserImport,
});
